export default __webpack_public_path__ + "static/media/Me.6200b922.png";